import { TemplateRef } from '@angular/core';

import { GridAlignment } from '@grid/enums';
import { IIdentity } from '.';

export interface HeaderOptions<T extends IIdentity> {
  name?: string;
  icon?: string;
  tooltip?: string;
  useTemplate?: boolean;
  template?: TemplateRef<any>;
  customClass?: string;
  alignment?: GridAlignment | ((data: T) => GridAlignment);
}
